import { Tabs } from 'antd';

import { useAppSelector } from 'app/store';

import { viewerModel } from 'entities/viewer';

import { TItemsTab } from 'shared/types/types';
import { RolesUser } from 'shared/enums';
import { configTabs } from 'shared/helpers/utils';
import { useTabsNavigate } from 'shared/hooks';

import ReferencesPull from './referencesPull';
import ReferencesInProgress from './referencesInProgress';
import ReferencesArchive from './referencesArchive';
import ReferencesInWaiting from './referencesInWaiting';
import ReferencesArchiveSubordinates from './referencesArchiveSubordinates';
import ReferencesSubordinates from './referencesSubordinates';
import style from './index.module.scss';

const itemsTab: TItemsTab = [
  {
    label: 'Общий список заявок',
    key: 'new',
    children: <ReferencesPull />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Подчинённые',
    key: 'other',
    children: <ReferencesSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
  {
    label: 'В работе',
    key: 'my',
    children: <ReferencesInProgress />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'В ожидании',
    key: 'myWaiting',
    children: <ReferencesInWaiting />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Архив',
    key: 'myArchive',
    children: <ReferencesArchive />,
    role: [RolesUser.HRDirector, RolesUser.Consultant],
  },
  {
    label: 'Архив подчинённых',
    key: 'subordinatesArchive',
    children: <ReferencesArchiveSubordinates />,
    role: [RolesUser.HRDirector, RolesUser.SecondLine],
  },
];

const References = () => {
  const [activeTab, handler] = useTabsNavigate('references', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);

  return (
    <div className={style.wrap}>
      {role && (
        <Tabs activeKey={activeTab} onChange={handler} destroyInactiveTabPane>
          {tabPane &&
            tabPane?.map(el => {
              return (
                <Tabs.TabPane tab={el.label} key={el.key}>
                  {el.children}
                </Tabs.TabPane>
              );
            })}
        </Tabs>
      )}
    </div>
  );
};

export default References;
